import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'mh-semantic-indicator',
    templateUrl: './semantic-indicator.component.html',
    styleUrls: ['./semantic-indicator.component.scss'],
    standalone: false
})
export class SemanticIndicatorComponent implements OnInit {
  @Input() title: string = 'models.hotel_dto.semantic';
  @Input() positivePercentage: number = 50;
  @Input() actionText: string = 'commons.see_more';
  @Input() empty: boolean = false;
  @Input() hideActionButton: boolean = false;
  @Output() onActionClick: EventEmitter<void> = new EventEmitter<void>();

  negativePercentage: number = 50;

  ngOnInit(): void {
    this.calculateNegativePercentage();
  }

  ngOnChanges(): void {
    this.calculateNegativePercentage();
  }

  private calculateNegativePercentage(): void {
    this.negativePercentage = 100 - this.positivePercentage;
  }

  handleActionClick(): void {
    this.onActionClick.emit();
  }
}
